import React from 'react'
import {
    Box,
    Card,
    CardHeader,
    Tabs,
    Tab,
    Typography,
    Grid,
    IconButton,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    FormControlLabel,
    Checkbox,
    Select,
    OutlinedInput,
    FormControl,
    MenuItem,
    Popover
} from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';


let types = [
    {
        "alerttype": "incident",
        "name": "Incident",
        "description": "accidents, traffic signal outages, and other unscheduled roadway events"
    },
    {
        "alerttype": "congestion",
        "eventtypes": "mainline_congestion,ramp_congestion",
        "name": "Congestion",
        "description": "traffic slow downs"
    },
    {
        "alerttype": "roadwork",
        "name": "Roadwork",
        "description": "scheduled road construction and other maintenance that affects roadways"
    },
    /*{
        "alerttype": "special_event",
        "name": "Special Events",
        "description": "scheduled and unscheduled events which may cause roadway closures"
    }*/
]
const impactLevels = ["All", "Low", "Medium", "High", "Closed"];

const HelpDialog = (props) => {
    const open = props.open;
    const handleClose = props.handleClose;
    return (
        <Dialog onClose={handleClose} open={open}>
            <DialogTitle>Event Types and Impact Levels</DialogTitle>
            <DialogContent dividers>
                <Grid
                    container
                    spacing={2}
                >
                    <Grid
                        item
                        lg={6}
                        xs={12}
                    >
                        <Typography variant="subtitle">Event Types</Typography>
                        <Typography variant="body2" sx={{ marginLeft: 5, marginTop: 1 }}>
                            <ul>
                                {types.map(type => {
                                    return <li key={type.name}>{type.name} are for {type.description}</li>
                                })}
                            </ul>
                        </Typography>
                    </Grid>
                    <Grid
                        item
                        lg={6}
                        xs={12}
                    >
                        <Typography variant="subtitle">Impact Levels</Typography>
                        <Typography variant="body2" sx={{ marginLeft: 5, marginTop: 1 }}>
                            <ul>
                                <li>Low: No known delays</li>
                                <li>Medium: Moderate delays</li>
                                <li>High: Significant delays</li>
                                <li>Closed: One or both directions of travel closed</li>
                            </ul>
                        </Typography>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button autoFocus onClick={handleClose}>
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    )
}

const SpecialAlert = (props) => {
    const [anchorEl, setAnchorEl] = React.useState(null)
    const setSelectedProfile = props.setSelectedProfile;
    const selectedProfile = props.selectedProfile;
    const included = props.included;

    const handlePopoverOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handlePopoverClose = () => {
        setAnchorEl(null);
    };

    const handleCheckboxChange = (e) => {
        const checked = e.target.checked;
        const name = e.target.name;
        var regionlessEventTypes = selectedProfile.regionlessEventTypes;
        if(!checked) {
            const idx = regionlessEventTypes.indexOf(name);
            if(idx > -1) {
                regionlessEventTypes.splice(idx,1);
            }
        } else {
            regionlessEventTypes.push(name);
        }
        selectedProfile.regionlessEventTypes = regionlessEventTypes;
        setSelectedProfile({...selectedProfile});
    }

    return (
        <>
            <Grid
                item
                lg={6}
                xs={12}
            >
                <FormControlLabel control={<Checkbox checked={included} name={"Special Alert"} onChange={handleCheckboxChange}/>} label={"Special Alerts"} />
                <IconButton aria-label="delete" size="small"
                    aria-haspopup="true"
                    onMouseEnter={handlePopoverOpen}
                    onMouseLeave={handlePopoverClose}>
                    <HelpOutlineIcon fontSize="inherit" />
                </IconButton>
                <Popover
                    id="mouse-over-popover"
                    sx={{
                        pointerEvents: 'none',
                    }}
                    open={null !== anchorEl}
                    anchorEl={anchorEl}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                    onClose={handlePopoverClose}
                    disableRestoreFocus
                >
                    <Typography sx={{ p: 2 }}>(Special Alerts include all Impact Levels, and are not constrained by area)</Typography>
                </Popover>
            </Grid>
        </>

    )
}

const EventType = (props) => {
    const [anchorEl, setAnchorEl] = React.useState(null)
    const setSelectedProfile = props.setSelectedProfile;
    const selectedProfile = props.selectedProfile;

    const handlePopoverOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handlePopoverClose = () => {
        setAnchorEl(null);
    };

    const handleChange = (e) => {
        const value = e.target.value;
        const name = e.target.name;
        var allImpactEventTypes = selectedProfile.allImpactEventTypes;
        var eventTypeImpacts = selectedProfile.eventTypeImpacts;     
        if(value === "All") {
            if(!allImpactEventTypes.includes(name)) {
                allImpactEventTypes.push(name);
            }
            if(undefined !== eventTypeImpacts[name]) {
                delete eventTypeImpacts[name];
            }
        } else if (value !== "") {
            const idx = allImpactEventTypes.indexOf(name);
            if(idx > -1) {
                allImpactEventTypes.splice(idx,1);
            }
            eventTypeImpacts[name] = value;
        } else {
            const idx = allImpactEventTypes.indexOf(name);
            if(idx > -1) {
                allImpactEventTypes.splice(idx,1);
            }
            delete eventTypeImpacts[name];
        }
        selectedProfile.eventTypeImpacts = eventTypeImpacts;
        selectedProfile.allImpactEventTypes = allImpactEventTypes;
        setSelectedProfile({...selectedProfile});
    }

    const handleCheckboxChange = (e) => {
        const checked = e.target.checked;
        const name = e.target.name;
        var allImpactEventTypes = selectedProfile.allImpactEventTypes;
        var eventTypeImpacts = selectedProfile.eventTypeImpacts;
        if(!checked) {
            const idx = allImpactEventTypes.indexOf(name);
            if(idx > -1) {
                allImpactEventTypes.splice(idx,1);
            }
            delete eventTypeImpacts[name];
        } else {
            allImpactEventTypes.push(name);
        }
        selectedProfile.eventTypeImpacts = eventTypeImpacts;
        selectedProfile.allImpactEventTypes = allImpactEventTypes;
        setSelectedProfile({...selectedProfile});
    }

    const type = props.type;
    const included = props.included;
    const defaultValue = props.impactLevel?props.impactLevel:"";

    return (
        <Grid
            item
            lg={12}
            xs={12}
        >
            <FormControlLabel sx={{ width: 225 }} control={<Checkbox checked={included} onChange={handleCheckboxChange} name={type.name}/>} label={type.name} />
            <FormControl sx={{ paddingRight: 5, width: 400 }}>
                <Select
                    name={type.name}
                    displayEmpty
                    value={defaultValue}
                    onChange={handleChange}
                    input={<OutlinedInput />}
                    renderValue={(selected) => {
                        if (selected === "") {
                            return <em>Select a Level</em>;
                        } else {
                            return selected;
                        }
                    }}
                    inputProps={{ 'aria-label': 'Without label' }}
                >
                    {impactLevels.map((impact, idx) => (
                        <MenuItem
                            key={impact}
                            value={impact}
                        >
                            {impact}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
            <IconButton aria-label="delete" size="small"
                aria-haspopup="true"
                onMouseEnter={handlePopoverOpen}
                onMouseLeave={handlePopoverClose}>
                <HelpOutlineIcon fontSize="inherit" />
            </IconButton>
            <Popover
                id="mouse-over-popover"
                sx={{
                    pointerEvents: 'none',
                }}
                open={null !== anchorEl}
                anchorEl={anchorEl}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                onClose={handlePopoverClose}
                disableRestoreFocus
            >
                <Typography sx={{ p: 2 }}>{type.name} are for {type.description}</Typography>
            </Popover>
        </Grid>
    )
}

export const EventTypes = (props) => {
    const selectedProfile = props.selectedProfile;
    const [open, setOpen] = React.useState(false);

    const handleClick = () => {
        setOpen(isOpen => !isOpen);
    };

    const handleClose = () => {
        setOpen(false);
    }

    return (
        <>
            <Box sx={{ marginBottom: 2 }}>
                <Typography variant="h6">Event Types & Impact Levels
                    <IconButton aria-label="delete" size="small" onClick={handleClick}>
                        <HelpOutlineIcon fontSize="inherit" />
                    </IconButton></Typography>
                <Typography variant="body2" sx={{ marginBottom: 2, marginTop: 2 }}>Select the event types and impact levels for which you want to receive alerts.</Typography>
                <Typography variant="body2" sx={{ marginBottom: 2, marginTop: 2 }}>The selected Impact Level is the lowest impact level for which you want to receive alerts. For example, if you chose Medium, you will receive alerts for events at impact levels Medium, High, and Closed.</Typography>
            </Box>
            <Box>
                <Grid
                    container
                    spacing={2}
                >
                    {types.map(type => {
                        const impactLevelType = selectedProfile?.eventTypeImpacts[type.name];
                        const allImpacts = selectedProfile?.allImpactEventTypes.includes(type.name);
                        return <EventType type={type} key={type.name} included={selectedProfile?.eventTypeImpacts[type.name] !== undefined || allImpacts} impactLevel={allImpacts?"All":impactLevelType} {...props}/>
                    })}
                    <SpecialAlert included={selectedProfile?.regionlessEventTypes.includes("Special Alert")} {...props}/>
                </Grid>
            </Box>
            <HelpDialog open={open} handleClose={handleClose} />
        </>
    )
}